import "./Navbar.scss";
import { changeItemSelection } from "@/helpers/commonHelper";

export default {
  name: "Navbar",
  props: ["modules"],
  data: () => ({
    preventNavigation: false,
    showMenu: false,
    hoveredGroupId: null,
    drawerMini: true,
    collapseTimeout: null,
    expandTimeout: null
  }),
  async mounted() {
    await this.$store.dispatch("getNavbarItems");
    if (!this.user) {
      await this.$store.dispatch("getCurrentUser");
    }
    this.applyMenuDebugState();
  },
  methods: {
    changeItemSelection,
    isTruthyQueryParam(value) {
      if (value === "") return true;
      if (typeof value === "boolean") return value;
      if (typeof value === "number") return value === 1;
      if (typeof value !== "string") return false;

      const normalized = value.toLowerCase();
      return ["1", "true", "yes", "on"].includes(normalized);
    },
    applyMenuDebugState() {
      const shouldOpen = this.menuDebugEnabled;
      this.clearCollapseTimeout();
      this.clearExpandTimeout();
      this.drawerMini = shouldOpen ? false : !this.navbarExpanded;
      if (!shouldOpen && this.drawerMini) {
        this.hoveredGroupId = null;
      }
    },
    handleLogoClick() {
      if (this.$route.path === "/") return;
      this.$router.push("/");
    },
    clearCollapseTimeout() {
      if (!this.collapseTimeout) return;
      clearTimeout(this.collapseTimeout);
      this.collapseTimeout = null;
    },
    clearExpandTimeout() {
      if (!this.expandTimeout) return;
      clearTimeout(this.expandTimeout);
      this.expandTimeout = null;
    },
    handleMouseOver() {
      this.clearCollapseTimeout();
      this.clearExpandTimeout();
      this.expandTimeout = setTimeout(() => {
        this.drawerMini = false;
      }, 600);
    },
    handleMouseLeave() {
      if (this.menuDebugEnabled) return;
      this.clearCollapseTimeout();
      this.clearExpandTimeout();
      this.hoveredGroupId = null;
      this.drawerMini = true;
    },
    handleListMouseLeave() {
      if (!this.navbarExpanded) return;
      this.clearCollapseTimeout();
      this.clearExpandTimeout();
      this.collapseTimeout = setTimeout(() => {
        this.hoveredGroupId = null;
        this.collapseTimeout = null;
      }, 220);
    },
    handleGroupMouseEnter(itemId, tryAgain = true) {
      if (!this.navbarExpanded) {
        if (tryAgain) {
          setTimeout(() => this.handleGroupMouseEnter(itemId, false), 600);
        }
        return;
      }
      this.clearCollapseTimeout();
      this.clearExpandTimeout();
      if (this.hoveredGroupId === itemId) return;
      this.expandTimeout = setTimeout(() => {
        this.hoveredGroupId = itemId;
        this.expandTimeout = null;
      }, 400);
    },
    handleGroupMouseLeave(itemId) {
      if (!this.navbarExpanded) return;
      this.clearCollapseTimeout();
      this.clearExpandTimeout();
      this.collapseTimeout = setTimeout(() => {
        if (this.hoveredGroupId === itemId) {
          this.hoveredGroupId = null;
        }
        this.collapseTimeout = null;
      }, 280);
    },
    isGroupExpanded(item) {
      if (!this.navbarExpanded) return false;
      return this.hoveredGroupId === item.id;
    },
    async logout() {
      localStorage.removeItem("authRefreshToken");
      localStorage.removeItem("session");
      localStorage.removeItem("impersonatedBy");
      localStorage.removeItem("selectedPrincipal");
      this.$store.state.session = null;
      this.$store.state.currentUser = null;
      this.$store.state.modules = null;
      window.location.href = "/login";
    }
  },
  computed: {
    hideNavbar() {
      return !Array.isArray(this.modules) || this.modules.length < 1;
    },
    navbarExpanded() {
      return this.$store.state.navbarExpanded;
    },
    menuDebugEnabled() {
      return this.isTruthyQueryParam(this.$route?.query?.menuDebug);
    },
    user() {
      return this.$store.state.currentUser;
    },
    adminModules() {
      return Array.isArray(this.modules)
        ? this.modules.filter(m => m.name === "Administration")
        : [];
    },
    appModules() {
      return Array.isArray(this.modules)
        ? this.modules.filter(m => m.name !== "Administration")
        : [];
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal;
    }
  },
  watch: {
    navbarExpanded(value) {
      this.preventNavigation = true;
      if (this.menuDebugEnabled) {
        this.drawerMini = false;
        return;
      }
      this.drawerMini = !value;
      if (!value) this.hoveredGroupId = null;
    },
    drawerMini(value) {
      if (this.menuDebugEnabled && value) {
        this.drawerMini = false;
        return;
      }
      this.$store.commit("SET_NAVBAR_EXPANDED", !value);
      if (value) this.hoveredGroupId = null;
    },
    "$route.query.menuDebug"() {
      this.applyMenuDebugState();
    }
  },
  beforeDestroy() {
    this.clearCollapseTimeout();
    this.clearExpandTimeout();
  }
};
